module.exports = __webpack_public_path__ + "img/cattunnel13.fd6ac94d.jpg";